export interface PrimingPage {
  questionIndex: number; // After which question to show this priming page (0-indexed)
  title: string;
  content: string;
  continueButtonText?: string;
}

// ⛔ MID-QUIZ INTERSTITIALS ARE REMOVED BY CLIENT DECISION — KEEP THIS EMPTY.
//
// 2026-08-20, McKayla Hajjar, on the call and again in her Loom "Current Site
// Feedback Part 3" (t=1:45). Verbatim from the call: "Ben had built in those,
// like, little things that pop up, like, five questions in, and it, like,
// you're doing great... Can we get rid of those? I don't need motivation as I
// go." And: "Like the third motivational message I got, I swiped out. I was
// like, I'm done." From the Loom: "What I don't like is the motivation, which
// we talked about. I don't want that in the middle."
//
// This is the only item in the 2026-08-20 feedback package that caused a
// measured abandonment — the client quit her own assessment over it.
//
// The single page that used to live here fired after question 10 and read
// "Amazing Progress! ... You're doing great!". It also asserted "This
// assessment has helped over 10,000 people", which is an unverified
// client-facing claim and a second reason it should not come back.
//
// Do NOT re-add entries to this array. The old comments here actively invited
// it ("Add priming pages by specifying the question index..."), which is why
// they have been removed. `primingPages.test.ts` fails if this array is
// non-empty — that test is the enforcement, not this comment.
//
// NOT affected, and deliberately still live: the POST-completion cards in
// pages/quiz.tsx (`showReviewsCard`, `showInfoCard`). Those render after the
// quiz ends, not in the middle of it, and the info card captures "where did
// you hear about us", which feeds advisor lead routing and was confirmed to
// stay by the 2026-08-03 written client decision. They reuse the PrimingCard
// component; removing that component would break them.
export const PRIMING_PAGES: PrimingPage[] = [];

// Helper function to check if a priming page should be shown after a specific question
export const shouldShowPrimingPage = (questionIndex: number): boolean => {
  return PRIMING_PAGES.some(page => page.questionIndex === questionIndex);
};

// Helper function to get the priming page for a specific question index
export const getPrimingPage = (questionIndex: number): PrimingPage | null => {
  return PRIMING_PAGES.find(page => page.questionIndex === questionIndex) || null;
};
